import React from "react";
import { createPortal } from "react-dom";

const CONFETTI_COLORS = [
  "#111111",
  "#ef4444",
  "#f59e0b",
  "#22c55e",
  "#2563eb",
  "#ec4899",
];

const randomBetween = (min, max) => Math.random() * (max - min) + min;

export const createConfettiPieces = (
  count = 28,
  {
    leftRange = [12, 88],
    topRange = [6, 22],
    xRange = [-180, 180],
    yRange = [120, 260],
  } = {},
) =>
  Array.from({ length: count }, (_, index) => {
    const size = randomBetween(6, 12);

    return {
      id: `${index}-${Math.random().toString(36).slice(2, 8)}`,
      left: `${randomBetween(leftRange[0], leftRange[1]).toFixed(2)}%`,
      top: `${randomBetween(topRange[0], topRange[1]).toFixed(2)}%`,
      x: `${randomBetween(xRange[0], xRange[1]).toFixed(0)}px`,
      y: `${randomBetween(yRange[0], yRange[1]).toFixed(0)}px`,
      rotate: `${randomBetween(-260, 260).toFixed(0)}deg`,
      delay: `${randomBetween(0, 0.28).toFixed(2)}s`,
      duration: `${randomBetween(1.45, 2.35).toFixed(2)}s`,
      width: `${size.toFixed(0)}px`,
      height: `${(size * randomBetween(1.2, 1.9)).toFixed(0)}px`,
      radius: `${randomBetween(1, 999).toFixed(0)}px`,
      color:
        CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
    };
  });

const ConfettiBurst = ({ active, pieces = [], className = "", portal = false }) => {
  if (!active || !pieces.length) {
    return null;
  }

  const content = (
    <div className={`pointer-events-none overflow-hidden ${className}`} aria-hidden="true">
      <style>
        {`
          @keyframes indorinama-confetti-burst {
            0% {
              opacity: 0;
              transform: translate3d(0, -14px, 0) scale(0.5) rotate(0deg);
            }
            12% {
              opacity: 1;
            }
            100% {
              opacity: 0;
              transform: translate3d(var(--confetti-x), var(--confetti-y), 0)
                scale(1) rotate(var(--confetti-rotate));
            }
          }
        `}
      </style>

      {pieces.map((piece) => (
        <span
          key={piece.id}
          className="absolute block"
          style={{
            left: piece.left,
            top: piece.top,
            width: piece.width,
            height: piece.height,
            borderRadius: piece.radius,
            backgroundColor: piece.color,
            opacity: 0,
            "--confetti-x": piece.x,
            "--confetti-y": piece.y,
            "--confetti-rotate": piece.rotate,
            animationName: "indorinama-confetti-burst",
            animationDuration: piece.duration,
            animationDelay: piece.delay,
            animationFillMode: "forwards",
            animationTimingFunction: "cubic-bezier(.2,.82,.22,1)",
            boxShadow: "0 8px 18px rgba(15, 23, 42, 0.12)",
          }}
        />
      ))}
    </div>
  );

  if (portal && typeof document !== "undefined") {
    return createPortal(content, document.body);
  }

  return content;
};

export default ConfettiBurst;
